export const environment = {
  // WWUBaseUrl: 'https://japembzd8m.us-east-1.awsapprunner.com/api',
  // apiBaseUrl: 'https://user-dev-be.tsin.ca/api',
  WWUBaseUrl: 'https://ukammvdjzt.us-east-1.awsapprunner.com/api',
  apiBaseUrl: 'https://auth.tsin.ca/api',
  authBaseUrl: 'https://auth.tsin.ca/api',
  proBaseUrl: 'https://pro-be1.tsin.ca/api',
  authUrl: 'https://portal1.tsin.ca',
  learningServiceUrl: "https://learn.tsin.ca",
  paymentServiceUrl: "https://payment.tsin.ca",
  production: true,
  salt: 'ZC\f?.Kp[jnhXf3-"<f3{/tZS@#~(8on',
  proServiceUrl: "https://pro.tsin.ca",
  workwithusServiceUrl: "https://work-with-us.tsin.ca",
  recaptchaSiteKey: '6LeGUecqAAAAAG7TT48TUcRNZTvZn7bTlZC9W5FP',
  examServiceUrl: "http://exam.tsin.ca",
};
